const defaultConfig = {
  LANGUAGE: 'de',

  // OLD CONFIG
  responsive: {
    mobile: 768
  }
}

const overrideConfig = {}

export function readFromComponentOptions (opts) {
  for (var i in opts) {
    if (Object.prototype.hasOwnProperty.call(cfg, i)) {
      cfg[i] = opts[i]
    }
  }
}
export function readFromHtmlJson (cfg) {
  const el = document.querySelector('#baseconfig')
  if (el && el.getAttribute('type') === 'application/json') {
    const data = JSON.parse(el.innerHTML.replace(/^\s+/, ''))
    return data
  }
  return {}
}

export function updateConfig () {
  const config = cfg || { ...defaultConfig }
  Object.assign(config, overrideConfig)
  Object.assign(config, readFromHtmlJson(config))
  Object.assign(config, overrideConfig)
  return config
}

var cfg = updateConfig()
export const config = cfg
